import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import AuthLayout from './layouts/AuthLayout';
import FrontLayout from './layouts/FrontLayout';
import InnerLayout from "./layouts/InnerLayout";

import Home from './pages/Home';



const CreateRoutes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route path='/' element={<FrontLayout/>}>
            <Route path='/' exact element={<Home/>} />
          </Route>
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default CreateRoutes;